<template>
  <div>
    <p>
      <span>{{ title }}{{ codeNum }}</span>
      <span v-show="isCopy" class="copy-btn" :data-clipboard-text="codeNum" ref="copy" @click="copyFrom">复制</span>
      <span v-show="!isCopy" class="btn" @click="getPlan()">查看</span>
    </p>
  </div>
</template>

<script>
import { getFormData } from '@/api/api';
import { getPlainInfo } from "@/api/url";
import Clipboard from "clipboard";

export default {
  name: "GetPlain",
  props: {
    title: {
      type: String,
      default: '',
    },
    code: {
      type: String,
      default: '',
    },
    uid: {
      type: String,
      default: '',
    },
    //type：9=手机号，10=身份证号，11=微信二维码，12=身份证图片
    type: {
      type: Number,
      default: 9,
    },
    //subType：type=10的时需传值，1=获取手机身份证号，2=获取芝麻认证身份证号，3=获取百度认证身份证号，4=获取认证通过的身份证号
    subType: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      codeNum: this.code,
      isCopy: false,
      clipboard: null,
    }
  },
  watch: {
    uid() {
      this.codeNum = this.code;
      this.isCopy = false;
    }
  },
  methods: {
    getPlan() {
      let param = {}
      param['uid'] = this.uid;
      param['type'] = this.type;
      param['subType'] = this.subType;
      getFormData( getPlainInfo, param ).then((data)=>{
        let {code, msg} = data;
        if( code == 200 ) {
          if ( this.type == 9  ) {
            this.codeNum = data.data.phone;
            this.isCopy = true;
          }
          if ( this.type == 10 ) {
            this.codeNum = data.data.identityCode;
            this.isCopy = true;
          }
        } else {
          this.$message({
            showClose: true,
            duration: 1000,
            message: msg,
            type: 'warning'
          })
        }
      }).catch(()=>{

      })
    },

    //复制
    copyFrom(){
      this.clipboard.on('success',e =>{
        this.$message({
          showClose: true,
          duration: 1000,
          message: '复制成功',
          type: 'success'
        })
        this.clipboard.destroy() //使用destroy可以清除缓存
        this.clipboard = new Clipboard(this.$refs.copy)
      })
      this.clipboard.on('error',e =>{
        this.$message({
          showClose: true,
          duration: 1000,
          message: '复制失败',
          type: 'success'
        })
        this.clipboard.destroy()
        this.clipboard = new Clipboard(this.$refs.copy)
      })
    },

  },
  mounted() {
    this.clipboard = new Clipboard(this.$refs.copy)
  },
  unmounted() {
    this.clipboard.destroy()
  }
}
</script>

<style scoped>
.btn {
  color: #409eff;
  cursor: pointer;
  margin-left: 8px;
}
.copy-btn {
  color: #42b983;
  cursor: pointer;
  margin-left: 8px;
}
</style>
